import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import Modalizer from 'components/modalizer/modalizer'
import MatchingPairsStudentView from 'views/slides/activities/matching_pairs/student/view'

import styles from './preview_modal.scss'
import buildGrid, {filterGrid} from 'helpers/grid_builder'

class PreviewModal extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			pair_data: null,
			modal_width: 0,
			modal_height: 0,
		}
	}


	handleResize() {
		const HEADER_HEIGHT = 45
		const MODALIZER_INTERNAL_HORIZONTAL_PADDING = 27
		const MODALIZER_INTERNAL_VERTICAL_PADDING = 27
		const MODALIZER_BORDER = 1
		const MODALIZER_HORIZONTAL_PADDING = 150
		const MODALIZER_VERTICAL_PADDING = 100
		const GRID_WIDTH = this.container.offsetWidth - MODALIZER_HORIZONTAL_PADDING - MODALIZER_INTERNAL_HORIZONTAL_PADDING * 2 - MODALIZER_BORDER * 2
		const GRID_HEIGHT = this.container.clientHeight - MODALIZER_VERTICAL_PADDING - HEADER_HEIGHT - MODALIZER_INTERNAL_VERTICAL_PADDING
		const TILE_COUNT = this.props.activityData.pairs.length * 2
		if (GRID_WIDTH <= 0 || GRID_HEIGHT <= 0 || TILE_COUNT === 0) {
			return
		}
		const CARD_RATIO = 1
		let results = buildGrid(GRID_WIDTH, GRID_HEIGHT, TILE_COUNT, CARD_RATIO)
		//Min tile size 120*120
		results = filterGrid(results, 120*120)
		if (results.length === 0) {
			//40px adjust for scrollbar
			const cols = GRID_WIDTH <= 400 ? 1 : 2
			const card_width = GRID_WIDTH / cols
			const card_height = card_width / CARD_RATIO
			results.push({
				width: card_width,
				height: card_height,
				size: card_width * card_height,
				cols,
				rows: Math.ceil(TILE_COUNT / cols),
			})
		}
		const card_size_data = results[0]
		const modal_width = card_size_data.width * card_size_data.cols
		const modal_height = card_size_data.height * card_size_data.rows + HEADER_HEIGHT + MODALIZER_INTERNAL_VERTICAL_PADDING
		this.setState({
			pair_data: card_size_data,
			modal_width: modal_width + MODALIZER_INTERNAL_HORIZONTAL_PADDING * 2 + MODALIZER_BORDER * 2 + 'px',
			modal_height: modal_height + 'px',
		})
	}

	componentDidMount() {
		this.handleResize()
	}

	render() {
		return (
			<div
				ref={elem => {
					this.container = elem
				}}
				style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}}>
				<Modalizer nopadding closeAction={this.props.closeHandler} width={this.state.modal_width} height={this.state.modal_height}>
					<div styleName='wrapper'>
						<MatchingPairsStudentView
							activityData={this.props.activityData}
						/>
					</div>
				</Modalizer>
			</div>
		)
	}
}

export default CSSModules(PreviewModal, styles, { allowMultiple: true })
